import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BookAppointmentModal from "./BookAppointmentModal";
import ScrollToTop from "./ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Layout = ({ children }) => {
  const contactRef = useRef(null);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [autoPopupShown, setAutoPopupShown] = useState(false);
  const lastScrollY = useRef(0);

  const openBooking = () => setBookingOpen(true);
  const closeBooking = () => setBookingOpen(false);

  const scrollToContact = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (!autoPopupShown && currentScrollY > 800 && currentScrollY > lastScrollY.current) {
        setBookingOpen(true);
        setAutoPopupShown(true);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [autoPopupShown]);

  return (
    <div className="App">
      <ScrollToTop />
      <ToastContainer position="top-right" autoClose={4000} />
      <Header scrollToContact={scrollToContact} onOpenBooking={openBooking} />
      {children({ scrollToContact, contactRef, openBooking })}
      <Footer />
      <BookAppointmentModal isOpen={bookingOpen} onClose={closeBooking} />
    </div>
  );
};

export default Layout;
